import { BacklogService } from '../services/BacklogService'

export const state = {
  loading: false,
  backlog: [],
}

export const mutations = {
  setBacklogLoading(currentState, loading) {
    currentState.backlog.loading = loading
  },
  setBacklog(currentState, backlog) {
    currentState.backlog.backlog = backlog
  },
}

export const actions = {
  loadBacklog({ commit, rootState }) {
    const clientid = rootState.authentication.userProfile.attributes.hublot_clientid[0]
    commit('setBacklogLoading', true)
    BacklogService.getBacklog(clientid)
      .then(backlogs => {
        commit('setBacklogLoading', false)
        commit('setBacklog', backlogs)
      })
  },
}
export default {
  state, actions, mutations,
}
